/**
 * Fair-price analytics payload builder (Milestone 9).
 */
import { FAIR_PRICE_ANALYTICS_EVENTS } from "../constants/automapAnalyticsEvents";
import { trackBuyerEvent } from "./buyerAnalytics";
import { getFairPriceViewModel, resolveFairPriceLabel } from "./fairPriceViewModel";

export function buildFairPriceAnalyticsPayload(listing, extra = {}) {
  if (!listing) return { ...extra };
  const vm = getFairPriceViewModel(listing);
  return {
    listingId: listing.id,
    listingSlug: listing.slug || listing.id,
    dealerId: listing.dealerId || null,
    city: listing.city || null,
    make: listing.make || null,
    model: listing.model || null,
    year: listing.year || null,
    priceCop: listing.priceCop ?? null,
    fairPriceLabel: vm.label || resolveFairPriceLabel(listing),
    fairPriceDeltaCop: listing.fairPriceDeltaCop ?? null,
    fairPriceConfidence: listing.fairPriceConfidence ?? null,
    fairPriceSampleSize: vm.sampleSize ?? null,
    sourcePage: extra.sourcePage || "fair_price",
    ...extra,
  };
}

export function trackFairPriceBuyerEvent(eventType, listing, extra = {}) {
  trackBuyerEvent(eventType, buildFairPriceAnalyticsPayload(listing, extra));
}

export function trackFairPriceEvent(eventType, metadata = {}) {
  trackBuyerEvent(eventType, metadata);
}

export { FAIR_PRICE_ANALYTICS_EVENTS };
